<ag-grid-angular #gamesHistoryTableGrid *ngIf="grid" class="ag-theme-balham w-100"
    [ngClass]="{'cx-one-ui sol-grid flex-fill border-0 d-block game-history-table' : cvConfigurationService.isCxOne, 'lato-regular overflow-auto' : !cvConfigurationService.isCxOne}"
    [ngStyle]="{'height': cvConfigurationService.isCxOne ? 'calc(100vh - 302px)' : 'calc(100vh - 320px)' }"
    [gridOptions]="grid"></ag-grid-angular>

<div class="brackets-container">
    <div class="modal-container" *ngIf="isExpandedView" (click)="closeExpandedView($event)">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <div class="maDetailsPopupClose close-modal show-on-load close-container btn-close"
                     (click)="closeExpandedView($event)"></div>
                <div>
                    <span class="bracket-title">{{ruleName}}</span>
                    <div>
                        <span class="metric-name" cvLocalizedText langSection="Games" langKey="Metric">Metric</span>:
                        {{selectedMetrics[0]?.abbrev}}
                    </div>
                </div>
            </div>
            <hr class="modal-divider" />
            <cv-bracket-view [data]="gs.selectedGame[0].HistoryBracketTournamentMatches"
                             [numberOfRounds]="gs.selectedGame[0].HistoryBracketTournamentDetails.NumberOfRounds"
                             [currentUser]="currentParticipant"
                             [selectedMetrics]="selectedMetrics"
                             [gameStarted]="true"
                             [assignedGroups]="gs.selectedGame[0].HistoryEligibility.AssignedGroups"
                             [rounds]="gs.selectedGame[0].HistoryBracketTournamentRounds">
            </cv-bracket-view>
        </div>
    </div>
</div>
